module.exports = __webpack_public_path__ + "static/img/36.c499635e.png";